const TAG_EXAM_SESSION_KEY = "edutopia_tag_exam_session";

const asArray = (value) => (Array.isArray(value) ? value : []);

const firstObject = (...values) =>
  values.find((value) => value && typeof value === "object" && !Array.isArray(value));

/** Flatten bank-style `{ question: { ... }, answers }` rows into the solve-exam shape. */
export function normalizeTagExamQuestion(item) {
  if (!item || typeof item !== "object") return item;
  const nested =
    item.question && typeof item.question === "object" && !Array.isArray(item.question)
      ? item.question
      : null;
  if (!nested) {
    return {
      ...item,
      id: item.id ?? item.question_id,
    };
  }
  return {
    ...nested,
    ...item,
    id: nested.id ?? item.question_id ?? item.id,
    question: nested.question ?? item.stem,
    answers: asArray(item.answers).length ? item.answers : asArray(nested.answers),
    image: item.image ?? nested.image,
    pdf: item.pdf ?? nested.pdf,
    comprehension: item.comprehension ?? nested.comprehension,
  };
}

export function unwrapTagExamCreate(payload) {
  const root = payload && typeof payload === "object" && !Array.isArray(payload) ? payload : {};
  const nestedObject =
    root.data && typeof root.data === "object" && !Array.isArray(root.data)
      ? root.data
      : null;

  // POST /students/student_exams/tags returns { data: Question[], exam_id }
  const questionsRaw =
    (Array.isArray(root.data) && root.data) ||
    (Array.isArray(nestedObject?.questions) && nestedObject.questions) ||
    (Array.isArray(nestedObject?.exam_questions) && nestedObject.exam_questions) ||
    (Array.isArray(nestedObject?.data) && nestedObject.data) ||
    (Array.isArray(root.questions) && root.questions) ||
    (Array.isArray(payload) && payload) ||
    [];

  const nestedExam = firstObject(
    nestedObject?.exam,
    nestedObject?.student_exam,
    root.exam,
    root.student_exam
  );
  const examId =
    root.exam_id ??
    root.student_exam_id ??
    nestedExam?.id ??
    nestedObject?.exam_id ??
    nestedObject?.student_exam_id ??
    nestedObject?.id ??
    questionsRaw[0]?.exam_id ??
    questionsRaw[0]?.student_exam_id;

  const examSource = nestedExam || nestedObject || {};
  const exam = {
    ...(examSource && !Array.isArray(examSource) ? examSource : {}),
    id: examId,
    name:
      nestedExam?.name ||
      nestedObject?.name ||
      root.name ||
      "Practice exam",
    total_count:
      examSource?.total_count ??
      examSource?.question_number ??
      questionsRaw.length,
  };
  delete exam.questions;
  delete exam.exam_questions;
  delete exam.data;

  return {
    exam,
    questions: questionsRaw.map(normalizeTagExamQuestion).filter((q) => q?.id != null),
  };
}

export function saveTagExamSession({ exam, questions }) {
  try {
    sessionStorage.setItem(
      TAG_EXAM_SESSION_KEY,
      JSON.stringify({ exam, questions })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function loadTagExamSession(examId) {
  try {
    const raw = sessionStorage.getItem(TAG_EXAM_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.questions?.length) return null;
    if (examId != null && String(parsed?.exam?.id) !== String(examId)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearTagExamSession() {
  try {
    sessionStorage.removeItem(TAG_EXAM_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
